import { z } from 'zod';

export const InputSchema = z.object({
    mobilePhone: z.object({
        number: z.string(),
        prefix: z.string(),
        country: z.string(),
    }),
});

export type ChangePhoneInput = z.infer<typeof InputSchema>;
